import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject } from '@digibricks/domains';
import { ScoreVisibilityType } from './score-visibility-type';
export var AssignmentDisplayStatusV2 = /*#__PURE__*/function (_ValueObject) {
  _inherits(AssignmentDisplayStatusV2, _ValueObject);

  var _super = _createSuper(AssignmentDisplayStatusV2);

  function AssignmentDisplayStatusV2() {
    _classCallCheck(this, AssignmentDisplayStatusV2);

    return _super.apply(this, arguments);
  }

  _createClass(AssignmentDisplayStatusV2, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }, {
    key: "isUpComing",
    value: function isUpComing() {
      return this.props === AssignmentDisplayStatusV2.upComing.value;
    }
  }, {
    key: "isOnGoing",
    value: function isOnGoing() {
      return this.props === AssignmentDisplayStatusV2.onGoing.value;
    }
  }, {
    key: "isGrading",
    value: function isGrading() {
      return this.props === AssignmentDisplayStatusV2.grading.value;
    }
  }, {
    key: "isCompleted",
    value: function isCompleted() {
      return this.props === AssignmentDisplayStatusV2.completed.value;
    }
  }], [{
    key: "getDisplayStatusForExamination",
    value: function getDisplayStatusForExamination(timestamp, startTime, endTime, scoreVisibilityTypeValue, hasPublishScoreInformation) {
      if (!startTime && !endTime) {
        return AssignmentDisplayStatusV2.onGoing;
      }

      var isStartTimeGreaterThanCurrentTime = startTime > timestamp;
      var isEndTimeLessThanOrEqualCurrentTime = endTime <= timestamp;

      if (isStartTimeGreaterThanCurrentTime) {
        return AssignmentDisplayStatusV2.upComing;
      }

      if (isEndTimeLessThanOrEqualCurrentTime) {
        if (!scoreVisibilityTypeValue) {
          return AssignmentDisplayStatusV2.completed;
        }

        if (scoreVisibilityTypeValue === ScoreVisibilityType.immediateViewAfterSubmit.value) return AssignmentDisplayStatusV2.completed;

        if (scoreVisibilityTypeValue === ScoreVisibilityType.manualPublishScore.value) {
          if (hasPublishScoreInformation) {
            return AssignmentDisplayStatusV2.completed;
          }

          return AssignmentDisplayStatusV2.grading;
        }
      }

      return AssignmentDisplayStatusV2.onGoing;
    }
  }, {
    key: "isUpComing",
    value: function isUpComing(value) {
      return value === AssignmentDisplayStatusV2.upComing.value;
    }
  }, {
    key: "isOnGoing",
    value: function isOnGoing(value) {
      return value === AssignmentDisplayStatusV2.onGoing.value;
    }
  }, {
    key: "isGrading",
    value: function isGrading(value) {
      return value === AssignmentDisplayStatusV2.grading.value;
    }
  }, {
    key: "isCompleted",
    value: function isCompleted(value) {
      return value === AssignmentDisplayStatusV2.completed.value;
    }
  }]);

  return AssignmentDisplayStatusV2;
}(ValueObject);

_defineProperty(AssignmentDisplayStatusV2, "resources", ['5', // upComing,
'6', // onGoing
'7', // grading
'8' // completed
]);

_defineProperty(AssignmentDisplayStatusV2, "upComing", new AssignmentDisplayStatusV2(AssignmentDisplayStatusV2.resources[0]));

_defineProperty(AssignmentDisplayStatusV2, "onGoing", new AssignmentDisplayStatusV2(AssignmentDisplayStatusV2.resources[1]));

_defineProperty(AssignmentDisplayStatusV2, "grading", new AssignmentDisplayStatusV2(AssignmentDisplayStatusV2.resources[2]));

_defineProperty(AssignmentDisplayStatusV2, "completed", new AssignmentDisplayStatusV2(AssignmentDisplayStatusV2.resources[3]));